export default "/react/logoVoicia-d75a44fb.png";